import { render, staticRenderFns } from "./OptionHealthPreferencesYN.vue?vue&type=template&id=0eed6752"
import script from "./OptionHealthPreferencesYN.vue?vue&type=script&lang=js"
export * from "./OptionHealthPreferencesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports